<script lang="ts">
        export let videoId: string;
        export let title = 'YouTube video';
        export let start: number | undefined = undefined;

        const sanitizeStart = (value: number | undefined) => {
                if (value === undefined || Number.isNaN(value) || value <= 0) return undefined;
                return Math.floor(value);
        };

        $: normalizedStart = sanitizeStart(start);
        $: baseUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
        $: embedUrl = normalizedStart ? `${baseUrl}?start=${normalizedStart}` : baseUrl;
</script>

<div class="aspect-video overflow-hidden rounded-xl border border-white/10 bg-black/40 shadow-lg">
        <iframe
                title={title}
                src={embedUrl}
                class="h-full w-full"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
        />
</div>
